export const defaultPixelDensity = 150;
export const centimetersPerInch = 2.54;
export const limitSize = 8000;
